import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Link as RadixLink } from '@radix-ui/react-navigation-menu';
import { useConfiguration } from '@travel-frontend/core';
import { IconExitToApp } from '@travel-frontend/icons';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';
import { Content, Button } from '../../../../components/AccountControl/components/DropdownMenu/components/index.js';
import { Container } from '../../../../components/AccountControl/components/DropdownMenu/components/Container.js';
import { useAuthentication } from '../../../../hooks/index.js';
import { Divider, Link } from '../../../../primitives/index.js';
export const DropdownMenu = forwardRef(function DropdownMenu({
  onClickItem,
  onLogout = noop,
  ...restProps
}, ref) {
  const {
    t
  } = useTranslation('accountControl');
  const origin = useConfiguration('origin');
  const loginUrl = useConfiguration('loginUrl');
  const portal = useConfiguration('portal');
  const {
    isLoggedIn,
    toggleWidget,
    doLogout
  } = useAuthentication();
  const handleLogout = () => {
    doLogout();
    onLogout();
  };
  const shouldDisplayVouchers = portal.startsWith('aidu');
  return _jsx(Container, {
    ref: ref,
    ...restProps,
    children: _jsx(Content, {
      children: isLoggedIn ? _jsxs(_Fragment, {
        children: [_jsx(RadixLink, {
          asChild: true,
          children: _jsx(Button, {
            as: Link,
            href: `${loginUrl}/travels`,
            onClick: onClickItem,
            children: t('myTravels')
          })
        }), _jsx(RadixLink, {
          asChild: true,
          children: _jsx(Button, {
            as: Link,
            href: `${loginUrl}/profile`,
            onClick: onClickItem,
            children: t('myProfile')
          })
        }), shouldDisplayVouchers && _jsx(RadixLink, {
          asChild: true,
          children: _jsx(Button, {
            as: Link,
            href: `${loginUrl}/vouchers`,
            onClick: onClickItem,
            children: t('vouchers')
          })
        }), _jsx(RadixLink, {
          asChild: true,
          children: _jsx(Button, {
            as: Link,
            href: `${origin}/service/faq`,
            target: "_blank",
            onClick: onClickItem,
            children: t('contact')
          })
        }), _jsx(Divider, {}), _jsxs(Button, {
          onClick: event => {
            onClickItem?.(event);
            handleLogout();
          },
          bold: true,
          wide: true,
          children: [t('logout'), _jsx(IconExitToApp, {})]
        })]
      }) : _jsxs(_Fragment, {
        children: [_jsx(Button, {
          onClick: event => {
            onClickItem?.(event);
            toggleWidget('signIn');
          },
          children: t('login')
        }), _jsx(Button, {
          onClick: event => {
            onClickItem?.(event);
            toggleWidget('registration');
          },
          children: t('register')
        }), _jsx(RadixLink, {
          asChild: true,
          children: _jsx(Button, {
            as: Link,
            href: `${origin}/service/faq`,
            target: "_blank",
            onClick: onClickItem,
            children: t('contact')
          })
        })]
      })
    })
  });
});